// Mean of key for a given type (default: 'heat')
export function meanByType(list, type = 'heat', key) {
  let sum = 0;
  let count = 0;

  for (const o of list || []) {
    const v = o?.[key];
    if (o?.type === type && Number.isFinite(v)) {
      sum += v;
      count += 1;
    }
  }
  return count ? sum / count : 0;
}
